module.exports = __webpack_public_path__ + "img/brainfit_banner_1.2c070ca9.jpg";